<div class="ai-paginator">
    <div class="ai-paginator__left">
        <span class="ai-paginator__info"
            >Exibindo {{ firstItem() }}–{{ lastItem() }} de
            {{ total() }}</span
        >

        <!-- Seletor de itens por página (opt-in via [pageSizeOptions]). -->
        @if (pageSizeOptions().length > 0) {
            <label class="ai-paginator__per-page">
                <span>Por página</span>
                <select
                    class="ai-paginator__per-page-select"
                    [ngModel]="pageSize()"
                    (ngModelChange)="onPageSizeChange($event)"
                >
                    @for (option of pageSizeOptions(); track option) {
                        <option [ngValue]="option">{{ option }}</option>
                    }
                </select>
            </label>
        }
    </div>

    <div class="ai-paginator__buttons">
        <ai-button
            [transparent]="true"
            [border]="'hidden'"
            (click)="onClickFirst()"
        >
            <ai-icon class="fa-solid fa-angles-left" />
        </ai-button>
        <ai-button
            [transparent]="true"
            [border]="'hidden'"
            (click)="onClickPrevious()"
        >
            <ai-icon class="fa-solid fa-chevron-left" />
        </ai-button>

        <!-- Desktop/tablet: botões numerados de página. -->
        <span class="ai-paginator__pages">
            <ng-container *ngIf="pagesShow()[0] > 1">
                <ai-icon class="fa-solid fa-ellipsis" />
            </ng-container>
            <ng-container *ngFor="let index of pagesShow()">
                <ai-button
                    [transparent]="true"
                    [border]="'hidden'"
                    [styleClass]="{ 'ai-is-active': currentPage() === index }"
                    [label]="index.toString()"
                    (click)="onClickPage(index)"
                ></ai-button>
            </ng-container>
            <ng-container
                *ngIf="pagesShow()[pagesShow().length - 1] < totalPages()"
            >
                <ai-icon class="fa-solid fa-ellipsis" />
            </ng-container>
        </span>

        <!-- Phone: dropdown para escolher a página (ocupa pouco espaço). -->
        <select
            class="ai-paginator__page-select"
            [ngModel]="currentPage()"
            (ngModelChange)="onPageChange($event)"
        >
            <option *ngFor="let page of allPages()" [ngValue]="page">
                {{ page }} / {{ totalPages() }}
            </option>
        </select>

        <ai-button
            [transparent]="true"
            [border]="'hidden'"
            (click)="onClickNext()"
        >
            <ai-icon class="fa-solid fa-chevron-right" />
        </ai-button>
        <ai-button
            [transparent]="true"
            [border]="'hidden'"
            (click)="onClickLast()"
        >
            <ai-icon class="fa-solid fa-angles-right" />
        </ai-button>
    </div>
</div>
